import { setHeaderHeight } from "../functions/setHeaderHeight";

export const initSetHeaderHeight = () => {
	return setHeaderHeight();
};
